import { writable } from 'svelte/store';
export const currentTime = writable(0);
export const duration = writable(-1);
export const streamStart = writable(new Date());
export const ready = writable(false);
export const playing = writable(false);
export const paused = writable(true);
export const seeking = writable(false);
